/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceTypeQueryOperator>): ResourceTypeQueryOperator {
        let obj = Object.assign(new ResourceTypeQueryOperator(), model);
        ResourceTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceTypeQueryOperator>): ResourceTypeQueryOperator {
        if (!model) return null;
        return ResourceTypeQueryOperator.newInstance(<ResourceTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceTypeQueryOperator) {
        if (!obj) return;

        models.ResourceTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * resource types to include
     */
    resource_types: Array<string>;

}
